import React from "react";
import CustomRow from "../../shared/costum-row/costum-row";
import { Col, Typography } from "antd";
import CustomImage from "../../shared/custom-image/custom-image";

import "./styles.scss";

const { Text } = Typography;

type BlogImagePropsType = {
  src: string;
  text?: string;
};

const BlogImage = ({ src, text }: BlogImagePropsType) => {
  return (
    <CustomRow className="BlogImage" gutter={[0, 10]}>
      <Col span={24}>
        <CustomImage src={src} className={`BlogImage-place`} />
      </Col>

      {text ? (
        <Col span={24}>
          <Text className="BlogImage-text">{text}</Text>
        </Col>
      ) : null}
    </CustomRow>
  );
};

export default BlogImage;
